/**
 * Created by Jerker Nord on 2022-04-19.
 */

export class TheBorderBitmapText extends PIXI.BitmapText {

    private _used:boolean;

    constructor(text:string, style:{
        fontName:string;
        fontSize?:number;
        align?:string;
        tint?:number;
        letterSpacing?:number;
        maxWidth?:number;
    }) {
        super(text, style);
        this._used = false;
    }

    get used():boolean {
        return this._used;
    }

    set used(value:boolean) {
        this._used = value;
    }
}